var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.show)?_c('router-view',{staticClass:"router-main"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }